import type { ApolloError } from "@apollo/client";
import { createContext } from "react";

import type { GenomeStatistics } from "@/graphql.ts";
import type { GenomeAnnotationsData } from "@/ui-modules/entities/genomes/graphql/useFetchGenomeStatistics.ts";

interface QueryState<T> {
  data: T | null | undefined;
  loading: boolean;
  error: ApolloError | undefined;
}

export interface GenomicAnnotationsContextData {
  genomicAnnotations: QueryState<GenomeAnnotationsData>;
  proteinStatistics: QueryState<Partial<GenomeStatistics>>;
}

export const GenomicAnnotationsContext = createContext<GenomicAnnotationsContextData>({
  genomicAnnotations: { loading: false, error: undefined, data: null },
  proteinStatistics: { loading: false, error: undefined, data: null },
});
